// extracted by mini-css-extract-plugin
var _1 = "ExternalSearchPreview-module__animateUploadProgressBarWidth--xRem5";
var _2 = "ExternalSearchPreview-module__animatedBackground--GVY8h";
var _3 = "ExternalSearchPreview-module__container--zyU6x";
var _4 = "ExternalSearchPreview-module__contentContainer--zHmMl";
var _5 = "ExternalSearchPreview-module__emptyContainer--dRs6t";
var _6 = "ExternalSearchPreview-module__footer--okje8";
var _7 = "ExternalSearchPreview-module__icon--GADFd";
var _8 = "ExternalSearchPreview-module__imageContainer--rCw3O";
var _9 = "ExternalSearchPreview-module__title--YEic6";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "contentContainer", _5 as "emptyContainer", _6 as "footer", _7 as "icon", _8 as "imageContainer", _9 as "title" }
